import { Button } from "../../components/Button";
import { HeaderContent } from "../../components/Header";
import { Grid } from "../../components/Table";
import "./styles.scss"

export const ScaleIndicatorScreen = ({
  esmIndicators,
  goToDetails,
}) => {
  const columns = [
    {
      id: 0,
      field: "title",
      label: "Titulo",
      width: "calc(100% - 720px)",
    },
    {
      id: 1,
      field: "category",
      label: "Categoria",
      width: "calc(100% - 1100px)",
    },
  ]

  return (
    <>
      <HeaderContent className="flex-end">
        <div className="esm-new">
          <Button handleClick={() => goToDetails()} label="Adicionar" color="orange" />
        </div>
      </HeaderContent>
      <Grid columns={columns} rows={esmIndicators} onRowClick={({ data }) => goToDetails(data?.id || '', true)}/>
    </>
  )
}
